"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _dateFns = require("date-fns");
var _APSelect = _interopRequireDefault(require("../../../common/APSelect/APSelect"));
var _APDatePicker = _interopRequireDefault(require("../../../common/APDatePicker/APDatePicker"));
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var RecentActivityHeaderFormComponent = function RecentActivityHeaderFormComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  var resetActivePage = props.resetActivePage,
    setEndDate = props.setEndDate,
    clearFilters = props.clearFilters,
    endDate = props.endDate;
  return /*#__PURE__*/_react["default"].createElement("form", {
    className: baseClasses('select-buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "type",
    customClass: baseClasses(),
    label: t('Activity type:'),
    options: [{
      value: 'all',
      label: t('All Activities')
    }, {
      value: 'trades',
      label: t('Trades')
    }, {
      value: 'withdraw',
      label: t('Withdrawals')
    }, {
      value: 'deposit',
      label: t('Deposits')
    }],
    onSelect: resetActivePage,
    showTriangles: true
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "startDate",
    customClass: baseClasses('from'),
    customChange: function customChange(value) {
      resetActivePage();
      if (value && !endDate) {
        setEndDate(new Date());
      }
    },
    label: t('Date range:'),
    format: function format(value) {
      return value;
    },
    maxDate: new Date()
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "endDate",
    customClass: baseClasses('to'),
    label: t('to'),
    format: function format(value) {
      return value;
    },
    parse: function parse(value) {
      return (0, _dateFns.endOfDay)(value);
    },
    customChange: resetActivePage,
    maxDate: new Date()
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    classModifiers: "clear-filters",
    type: "button",
    onClick: clearFilters
  }, t('Clear Filters')));
};
var _default = exports["default"] = RecentActivityHeaderFormComponent;